export class Navigation {
	constructor() {
		this.open = false
		this.toggle = document.querySelectorAll('[data-toggle-nav]')
		this.servicesLink = document.querySelector('.menu-services a')
		this.megaMenu = document.querySelector('.megamenu')
		this.menuItem2 = document.querySelector('#menu-item-2')

		this.toggle.forEach((button) => {
			button.addEventListener('click', () => {
				this.open ? this.closeNavigation() : this.openNavigation()
			})
		})

		// Only bind hover events on desktop
		if (this.servicesLink) {
			this.servicesLink.addEventListener('mouseenter', () => {
				if (window.innerWidth >= 1024) {
					this.showServices(true)
				}
			})

			this.servicesLink.addEventListener('mouseleave', () => {
				if (window.innerWidth >= 1024) {
					this.showServices(false)
				}
			})
		}

		// Mobile-specific megamenu toggle for menu-item-2
		if (this.menuItem2) {
			this.menuItem2.addEventListener('click', (e) => {
				if (window.innerWidth < 1024) {
					e.preventDefault()
					this.toggleMegaMenu()
				}
			})
		}
	}

	openNavigation() {
		this.open = true
		document.documentElement.classList.add('nav-open')
		document.documentElement.setAttribute('data-nav', 'open')

		this.toggle.forEach(button => {
			button.setAttribute('aria-expanded', 'true')
		})
	}

	closeNavigation() {
		this.open = false
		document.documentElement.classList.remove('nav-open')
		document.documentElement.setAttribute('data-nav', 'closed')

		this.toggle.forEach(button => {
			button.setAttribute('aria-expanded', 'false')
		})

		// Close megamenu if open
		this.closeMegaMenu()
	}

	showServices(show) {
		if (show) {
			this.megaMenu.classList.add('active')
		} else {
			this.megaMenu.classList.remove('active')
		}
	}

	toggleMegaMenu() {
		const html = document.documentElement
		const isOpen = html.classList.toggle('megamenu-open')
		if (isOpen) {
			html.setAttribute('data-megamenu', 'open')
		} else {
			html.removeAttribute('data-megamenu')
		}
	}

	closeMegaMenu() {
		const html = document.documentElement
		html.classList.remove('megamenu-open')
		html.removeAttribute('data-megamenu')
	}

	snapCloseNavigation() {}
}

export default () => {}